/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserHasMonitoredObjectGroupMany
 */
export interface UserHasMonitoredObjectGroupMany {
    /**
     * 
     * @type {Array<number>}
     * @memberof UserHasMonitoredObjectGroupMany
     */
    users: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserHasMonitoredObjectGroupMany
     */
    monitoredObjectGroups: Array<number>;
}

export function UserHasMonitoredObjectGroupManyFromJSON(json: any): UserHasMonitoredObjectGroupMany {
    return UserHasMonitoredObjectGroupManyFromJSONTyped(json, false);
}

export function UserHasMonitoredObjectGroupManyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserHasMonitoredObjectGroupMany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': json['users'],
        'monitoredObjectGroups': json['monitored_object_groups'],
    };
}

export function UserHasMonitoredObjectGroupManyToJSON(value?: UserHasMonitoredObjectGroupMany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users,
        'monitored_object_groups': value.monitoredObjectGroups,
    };
}


